import { Component, Input, Output, OnInit, ModuleWithComponentFactories } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KngDrawerService } from '@layout/kingswell/kingswell';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThingProvider } from '@providers/thing.provider';
import { TaskProvider } from '@providers/task.provider';
import { DeletGroupComponent } from '../delete/deleteGroup.component';
import { NotificationService } from '@core/notification/notification.service';
import { forEach } from '@angular/router/src/utils/collection';

interface MyFormGroup {
  [key: string]: any;
}

@Component({
  selector: 'group-edit-selector',
  templateUrl: './groupEdit.component.html',
  styleUrls: ['./groupEdit.component.less'],
})
export class GroupEditComponent {

  @Input()
  public things: any;
  @Input()
  public groupName: string = '';
  @Output()
  public result: string = '';

  title = '';
  inGroup = [];
  outGroup = [];
  form: FormGroup;
  tasks = [];
  avgCompletionTime: number = 0;
  isValid:boolean = false;

  public constructor(public activeModal: NgbActiveModal, private kngDrawer: KngDrawerService,
    private fb: FormBuilder, private thingProvider: ThingProvider, private notification: NotificationService,
    private taskProvider: TaskProvider) {
    this.form = this.fb.group(this.getFormMap());
  }

  getFormMap() {
    return {
      groupName: [this.groupName]
    };
  }

  ngOnInit() {
    this.groupName == '' ? this.title = 'Add New Group' : this.title = 'Edit Group';
    this.things.forEach(thing => {
      if (thing.groupName && thing.groupName == this.groupName)
        this.inGroup.push(thing);
      else
        this.outGroup.push(thing);
    });
    this.form.controls['groupName'].setValue(this.groupName);
    this.getTasks();

    this.inGroup = this.sortGroup(this.inGroup);
    this.outGroup = this.sortGroup(this.outGroup);
  }

  sortGroup(thingArray): any[] {
    // temp to replace outGroup
    var temp = [];
    var grouped = [];
    var notGrouped = [];
    //group outGroup, sort each group then append them
    thingArray.forEach(thing => {
      if (thing.groupName) {
        grouped.push(thing);
      } else {
        notGrouped.push(thing);
      }
    });
      grouped.sort((a,b) => {
        let aName = a.name ? a.name.toLowerCase() : a.thingId;
        let bName = b.name ? b.name.toLowerCase() : b.thingId;
  
        if (aName < bName) return -1;
        if (aName > bName) return 1;
  
        return 0;
      });
      notGrouped.sort((a,b) => {
        let aName = a.name ? a.name.toLowerCase() : a.thingId;
        let bName = b.name ? b.name.toLowerCase() : b.thingId;
  
        if (aName < bName) return -1;
        if (aName > bName) return 1;
  
        return 0;
      });
      temp = notGrouped.concat(grouped);

    return temp;
  }

  setGroupName(name) {
    this.groupName = name;
    this.validateThings();
  }

  addToOutGroup(event, thing) {
    event.preventDefault();
    console.log('remove from in group');
    this.outGroup.push(thing);
    this.inGroup = this.inGroup.filter(t => {
      return t.name != thing.name;
    });
    thing.groupName === this.groupName ? thing.groupName = null : '';
    
    // this.outGroup.sort((a,b) => {
    //   let aName = a.name ? a.name.toLowerCase() : a.thingId;
    //   let bName = b.name ? b.name.toLowerCase() : b.thingId;

    //   if (aName < bName) return -1;
    //   if (aName > bName) return 1;

    //   return 0;
    // });
    this.outGroup = this.sortGroup(this.outGroup);
    this.calAvgTime();
    this.validateThings();
  }

  addToInGroup(event, thing) {
    console.log('adding to ingroup: ', thing);
    console.log('tasks: ', this.tasks);
    event.preventDefault();
    console.log('add to in group');
    this.inGroup.push(thing);
    this.outGroup = this.outGroup.filter(t => {
      return t.name != thing.name;
    });
    // this.inGroup.sort((a,b) => {
    //   let aName = a.name ? a.name.toLowerCase() : a.thingId;
    //   let bName = b.name ? b.name.toLowerCase() : b.thingId;

    //   if (aName < bName) return -1;
    //   if (aName > bName) return 1;

    //   return 0;
    // });
    //this.inGroup = this.sortGroup(this.inGroup);
    this.inGroup = this.sortGroup(this.inGroup);
    this.calAvgTime();
    this.validateThings();
  }

  getTasks() {
    this.tasks = [];
    let areaId = this.getAreaId();
    this.taskProvider.getTasks({
      area: areaId,
      status: 'Completed'
    }).then(tasks => {
      this.tasks = tasks;
      this.calAvgTime();
    });
  }

  getAreaId(): string {
    return this.things[0].area;
  }

  calAvgTime() {
    let sum = 0;
    let total = 0;
    this.tasks.forEach(task => {
      if (this.isInInGroup(task.name)) {
        total++;
        sum += (new Date(task.completeDateTime).getTime() - new Date(task.createDateTime).getTime()) / (1000 * 60);
      }
    })
    total == 0 ? total = 1 : total = total;
    this.avgCompletionTime = Math.floor(sum / total);
  }

  isInInGroup(name) {
    let result = false;
    this.inGroup.forEach(thing => {
      if (thing.name == name) {
        result = true;
      }
    });
    return result;
  }

  deleteGroup() {
    this.activeModal.close('delete');
  }

  submitForm(value: any) {
    // validate things
    if (!this.validateThings()) {

      return;
    }

    // set group name
    this.inGroup.forEach(thing => {
      thing.groupName = this.groupName;
    });
    this.outGroup.forEach(thing => {
      if (thing.groupName && thing.groupName == this.groupName) {
        thing.groupName = null;
      }
    });
    // update things
    this.inGroup.forEach((thing, index) => {
      this.thingProvider.updateThing(thing)
        .then(res => {
          // if (this.outGroup.length == 0 && index == this.inGroup.length - 1) {
          //   this.notification.show('success', 'Saved groups');
          //   this.activeModal.close();
          // }
        })
        .catch(err => {
          this.notification.show('alert', 'Something went wrong.');
        });
    });
    this.outGroup.forEach((thing, index) => {
      this.thingProvider.updateThing(thing)
        .then(res => {
          if (index == this.outGroup.length - 1) {
            this.notification.show('success', 'Saved groups.');
            this.activeModal.close();
          }
        })
        .catch(err => {
          this.notification.show('alert', 'Something went wrong.');
        });
    });
  }

  validateThings(): boolean {
    // no group can have only one restroom in it
    let counts = {};
    let isValid = true;;
    if (this.inGroup.length <= 1) {
      isValid = false;
    }
    this.outGroup.forEach(thing => {
      if (thing.groupName && thing.groupName != this.groupName) {

        if (!counts[thing.groupName])
          counts[thing.groupName] = 0;
        counts[thing.groupName]++;
      }
    });

    for (var key in counts) {
      if (counts[key] == 1) {
        isValid = false;
      }
    }
    !isValid ? this.notification.show('alert', 'Group cannot have only one restroom') : '';

    // group name cannot be null or a copy of another group anme
    if (this.groupName == null || this.groupName == '') {
      isValid = false;
      this.notification.show('alert', 'Group Name cannot be blank.');
    }
    else {
      let duplicateGroupName:boolean = false;
      this.outGroup.forEach(thing => {
        if (thing.groupName && thing.groupName == this.groupName) {
          isValid = false;
          duplicateGroupName = true;
        }
      })
      if (duplicateGroupName) {
        this.notification.show('alert', 'Group Name cannot be a duplicate.');
      }
    }
    this.isValid = isValid;
    return isValid;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/restroomGroup/list/groupEdit.component.ts